import { HttpClient, HttpHeaders, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { wsPayloadResponse } from '../user/payload';
import { tap, catchError, map, switchMap } from 'rxjs/operators';
import { Stations } from './stations';
import { PlugpointEnvironment } from '../PlugpointEnvironment';
import { FirmwareUpdate } from './firmwareUpdate';
import { changeAvailability } from './changeAvailability';
import { Guid } from 'guid-typescript';
import { LogService } from '../logs/log.service';
import { ActivityLog } from '../logs/log';
import { AuthService } from 'src/app/auth/auth.service';
import { AddStation } from './addStation';
/**
    * @description  An object with the property evseId that is a Map of stationId and stationName
*/
export type StationsMap = { evseMap : Map<string,string>}


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json',  })
};

@Injectable()
export class StationsService {



  private url = '';
    private token = Guid.create().toString();
  public guid = true;
  constructor(
    public http: HttpClient,
    private authService: AuthService
  ) {
    this.url = PlugpointEnvironment.endpoint;
  }

  private formatDateForHistory(date?: Date | string, endOfDay: boolean = false): string | undefined {
    if (!date) {
      return undefined;
    }
    if (typeof date === 'string') {
      return date;
    }
    const workingDate = new Date(date);
    workingDate.setHours(endOfDay ? 23 : 0, endOfDay ? 59 : 0, endOfDay ? 59 : 0, endOfDay ? 999 : 0);
    const year = workingDate.getFullYear();
    const month = String(workingDate.getMonth() + 1).padStart(2, '0');
    const day = String(workingDate.getDate()).padStart(2, '0');
    const hours = String(workingDate.getHours()).padStart(2, '0');
    const minutes = String(workingDate.getMinutes()).padStart(2, '0');
    const seconds = String(workingDate.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  private buildHistoryPayload(startDate?: Date | string, endDate?: Date | string, vendorName?: string, stationList?: any[]) {
    const payload: any = {};
    const start = this.formatDateForHistory(startDate, false);
    const end = this.formatDateForHistory(endDate, true);
    if (start) payload.startDate = start;
    if (end) payload.endDate = end;
    if (vendorName) payload.vendorName = vendorName;
    if (stationList) payload.stationList = stationList;
    return payload;
  }

  private getGatewayAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'SessionID': Guid.create().toString()
    });
  }

  placeholder(vendorName: string): Promise<any> {
    console.log('started placeholder call')
    const   resse = [
      { location : "Location1",
        stations: [
          { stationId: "1", stationName: "Station1" },
          { stationId: "2", stationName: "Station2" },
          { stationId: "3", stationName: "Station3" },
          { stationId: "4", stationName: "Station4" },
          { stationId: "5", stationName: "Station5" },
          { stationId: "6", stationName: "Station6" },
          { stationId: "7", stationName: "Station7" },
          { stationId: "8", stationName: "Station8" },
          { stationId: "9", stationName: "Station9" },
          { stationId: "10", stationName: "Station10" },
        ]
      },
      { location : "Location2",
        stations: [
          { stationId: "11", stationName: "Station11" },
          { stationId: "12", stationName: "Station12" },
          { stationId: "13", stationName: "Station13" },
          { stationId: "14", stationName: "Station14" },
          { stationId: "15", stationName: "Station15" },
          { stationId: "16", stationName: "Station16" },
          { stationId: "17", stationName: "Station17" },
          { stationId: "18", stationName: "Station18" },
          { stationId: "19", stationName: "Station19" },
          { stationId: "20", stationName: "Station20" },
        ]
      },
      { location : "Location3",
        stations: [
          { stationId: "21", stationName: "Station21" },
          { stationId: "22", stationName: "Station22" },
          { stationId: "23", stationName: "Station23" },
          { stationId: "24", stationName: "Station24" },
          { stationId: "25", stationName: "Station25" },
          { stationId: "26", stationName: "Station26" },
          { stationId: "27", stationName: "Station27" },
          { stationId: "28", stationName: "Station28" },
          { stationId: "29", stationName: "Station29" },
          { stationId: "30", stationName: "Station30" },
        ]
      },
      { location : "Location4",
        stations: [
          { stationId: "31", stationName: "Station31" },
          { stationId: "32", stationName: "Station32" },
          { stationId: "33", stationName: "Station33" },
          { stationId: "34", stationName: "Station34" },
          { stationId: "35", stationName: "Station35" },
          { stationId: "36", stationName: "Station36" },
          { stationId: "37", stationName: "Station37" },
          { stationId: "38", stationName: "Station38" },
          { stationId: "39", stationName: "Station39" },
          { stationId: "40", stationName: "Station40" },
        ]
      }
    ]
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('resolved placeholder call')
        resolve(resse)
      }, 500)})
  }
  /*
      * FRAUD LATER
  */
  async triggerAllStations(): Promise<any> {
      const uri = `${PlugpointEnvironment.url}/overwatch/checkStationsResponse`
      return this.http.post(uri, "", { headers: this.getGatewayAuthHeaders(), responseType: 'text' }).toPromise();


  }
    getLocationsByVendor(vendorName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/location/${vendorName}`;
        const headers = this.getGatewayAuthHeaders();
        return this.http.get<any>(url, { headers })
    }

  getPrices(id: string): Observable<wsPayloadResponse> {
    if (this.guid == true) { this.token = Guid.create().toString(); }
    let data = {
      "stationPrices": {
        "stationId": id
      }
    }

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }

    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/stationPrices/v2', body, httpOptions);
  }
  getCPStations(): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "getNow": {
        "station": "all",
        "platform": "dashboard"
      }
    }

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }
    //console.log("body for getCPStations is: " + JSON.stringify(body));

    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/getNow/v2', body, httpOptions).pipe(
      // tap(_ => console.log("in call")),
      catchError(this.handleError<wsPayloadResponse>(`getHero id=`)));
  }

    getLocationStations(location: string, user?: string): Promise<any> {

    return this.http.get(`${PlugpointEnvironment.url}/gateway/api/helios/api/location/${location}/evses` ).toPromise();
  }



    getMapStations(coordinates?: any, km?: any): Observable<wsPayloadResponse> {
        if (this.guid == true) {
            this.token = Guid.create().toString();
        }
        let data;
        if (coordinates) {
            data = {
                "getNowForMap": {
                    "station": "all",
                    "coordinates": coordinates,
                    "km": km
                }
            }
        } else {
            data = {
                "getNowForMap": {
                    "station": "all"
                }
            }
        }

        let body = {
            "token": this.token,
            "action": "stationsData",
            "data": data
        }

        return this.http.post<wsPayloadResponse>(this.url + '/stationsData/getNowForMap', body, httpOptions);

    }

  async getStationsMap(): Promise<StationsMap> {
    return await this.http.get<StationsMap>(this.url + '/stations-data/evseMap').toPromise();
  }

  getCPHistory(startDate?: Date, endDate?: Date): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data;
    if (startDate) {
      var finalStart = new Date(startDate.getTime() + Math.abs(startDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 19).replace('T', ' ');
      var finalEnd = new Date(endDate.getTime() + Math.abs(endDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 19).replace('T', ' ');
      data = {
        "getHistory": {
          "station": "all",
          "startDate": finalStart,
          "endDate": finalEnd
        }
      }
    } else {
      data = {
        "getHistory": {
          "station": "all",
        }
      }
    }
    // console.log(finalEnd)

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }

    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/getHistory/v2', body, httpOptions);
  }

  getReports(startDate?: Date | string, endDate?: Date | string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-history`;
        const body = this.buildHistoryPayload(startDate, endDate);
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
  }

  getReportsForVendor(vendorName: string, startDate?: Date | string, endDate?: Date | string): Observable<any> {

        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-vendor-history`;
        const body = this.buildHistoryPayload(startDate, endDate, vendorName);
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });

  }

  async getHistory(startDate: any, endDate: any, vendor?: string) {
     const uri = new URL(PlugpointEnvironment.url +'/gateway/api/dashboard/get-history');
    uri.searchParams.append('startDate', startDate);
    uri.searchParams.append('endDate', endDate ? endDate : '');
     if (vendor) {
      uri.searchParams.append('vendor', vendor);
    }
    return await this.http.get<any>(uri.toString()).toPromise();
  }

  async getChartPoints(startDate: any, endDate: any, interval: 'year' | 'month' | 'day', stationList: any = [], vendor?: string) {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    if (endDate) {
      endDate = endDate.replace('00:00:00', '23:59:59');
    }
    const uri = new URL(PlugpointEnvironment.url + '/gateway/api/helios/dashboard/get-data-for-charts');
    const body = {
        intervalType: interval,
        startDate: startDate,
        endDate: endDate ? endDate : '',
        stationList: stationList,
        vendor: vendor
    }
    return await this.http.post(uri.toString(), body).toPromise();

  }

  getStationHistory(id: string, startDate?: string, endDate?: string): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "getHistory": {
        "station": id
      }
    }
    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }

    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/getHistory/v2', body, httpOptions);
  }

    updatePriceKw(id: string, priceKw: number): Observable<any> {

        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            chargingPrice: priceKw
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
    updatePriceH(id: string, priceH: number): Observable<any> {

        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            chargingPriceTimeCharging: priceH
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
    updatePriceB(id: string, priceB: number): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            chargingPriceTimeBusy: priceB
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    updatePriceStart(id: string, startPriceVendor: number): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            startPriceVendor: startPriceVendor
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
    updateStationProviderPrice(id: string, newB): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            providerPrice: +newB.providerPrice,
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
    updateStation(id: string, newB): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            stationVendor: newB.stationVendor,
            stationAddress: newB.stationAddress,
            stationName: newB.stationName,
            stationCoordinates: newB.stationCoordinates,
            chargingPower: newB.chargingPower,
            tags: newB.tags,
            reservable: newB.reservable,
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });

    }
    updatePriceStartChargePoint(id: string, startPricePP: number): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            startPricePP: startPricePP
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

  updateStationType(id: string, publicStation: boolean): Observable<any> {
      const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            publicStation: publicStation
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
  }

    updateStationPromo(id: string, promoId: number): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/update`;
        const body = {
            stationId: id,
            promotionDataId: promoId
        };
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    addStation(stationObj: AddStation): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/stations-data/add`;
        const body = JSON.stringify(stationObj);
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

  getStationsForVendor(vendorName: string): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "getStationByVendor": {
        "vendor": vendorName
      }
    }

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }
    //console.log("body for getStationsForVendor is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/getStationByVendor', body, httpOptions);
  }

  getStationsForSubscriber(userName: string) {
    const uri = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-subscriber-stations/${userName}`;
    return this.http.get(uri, { headers: this.getGatewayAuthHeaders() });
  }
  getLiveSessions(token: string): Observable<any> {
      const uri = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-live-sessions`;
      return this.http.get(uri, { headers: this.getGatewayAuthHeaders() });
  }

  getStationsForUser(userName: string): Observable<any> {
      const uri = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-user-stations/${userName}`;
      return this.http.get(uri, { headers: this.getGatewayAuthHeaders() });
  }

    getHistoryForSubscriber(userName: string) {
        const uri = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-subscriber-history/${userName}`

        return this.http.get(uri, { headers: this.getGatewayAuthHeaders() });
    }
  getHistoryForUser(userName: string, startDate: string | null = null, endDate: string | null = null): Observable<any> {
        const uri = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-user-history/${userName}/v2`;
        return this.http.get(uri, { headers: this.getGatewayAuthHeaders() });
  }
  getFleetHistory(vendorName: string, startDate: string | null = null, endDate: string | null = null): Observable<any> {
        const uri = `${PlugpointEnvironment.url}/gateway/api/stations-data/get-fleet-history`;
        const body = {
            startDate: startDate,
            endDate: endDate,
            vendorName: vendorName
        }
        return this.http.post(uri, body, { headers: this.getGatewayAuthHeaders() });
  }

  getStation(id: string): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "getNow": {
        "station": id,
        "platform": "dashboard"
      }
    }

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }

    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/getNow/v2', body, httpOptions);
  }


  public processData(data: any) {

    //process your data
    return data;//this is processed data
  }


    startChargingCustom(stationId: string, user: string, walletId: string, publicCharging: boolean, groupId: string): Observable<any> {

        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/station-start-custom`;
        const body = {
            stationId: stationId,
            user: user,
            walletId: walletId,
            publicCharging: publicCharging,
            groupUserInfoId: groupId
        };
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
//   startCharging(stationId: string, userId: string): Observable<wsPayloadResponse> {
//     if (this.guid == true) {
//       this.token = Guid.create().toString();
//     }
//     let data = {
//       "stationStart": {
//         "stationId": stationId,
//         "userId": userId,
//         "walletId": "none"
//       }
//     }
//     var encodedData = btoa(JSON.stringify(data));
//     if (userId.includes("3_")) {
//       let data_admin = {
//         "stationStart": {
//           "stationId": stationId,
//           "userId": "3",
//           "admin": userId,
//           "walletId": "none"
//         }
//       }
//       encodedData = btoa(JSON.stringify(data_admin));
//     }

//     let body = {
//       "token": this.token,
//       "action": "deviceCmd",
//       "data": encodedData
//     }
//     // //console.log("body for getStartCharging is: " + JSON.stringify(body));

//     return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
//   }


    startChargingWithWalletId(stationId: string, userId: string, walletId: string, userName: string, vendor?: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/start-charging`;
       let data: any = {
          "stationStart": {
              "stationId": stationId,
              "userId": userId,
              "walletId": walletId,
              "publicCharging": false,
              "userName": userName
          }
      };

        if (vendor) {
            data["stationStart"]["vendor"] = vendor;
        }
        let body = {
      "token": this.token,
      "action": "deviceCmd",
      "data": data
    }

        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

  stopCharging(stationId: string, userId: string, userName: string): Observable<wsPayloadResponse> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/stop-charging`;
        let data = {
      "stationStop": {
        "stationId": stationId,
        "userId": userId,
        "userName": userName
      }
    }

    let body = {
      "token": this.token,
      "action": "deviceCmd",
      "data": data
    }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
  }

  /*
      * not used
  */
  reserveStation(stationId: string, userName: string): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "reserveStation": {
        "stationId": stationId,
        "userName": userName
      }
    }
    var encodedData = btoa(JSON.stringify(data));

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": encodedData
    }
    // //console.log("body for reserveStation is: " + JSON.stringify(body));

    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

  unlock(stationId: string, userName: string): Observable<any> {
    const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/unlock-connector`;
    const body = {
        stationId:  stationId,
        userName: userName
    }
    return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
  }

  resetStation(stationId: string, userName: string): Observable<wsPayloadResponse> {
    const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
    const body = {
        stationId:  stationId,
        message: "reset&",
        userName: userName
    }
    return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
  }
//skip
  stopHangingSessionByStation(stationId: string): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "hangingSession": {
        "stationId": stationId,
      }
    }
    var encodedData = btoa(JSON.stringify(data));

    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": encodedData
    }
    // //console.log("body for reserveStation is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }
  stopHangingSessionByUser(userName: string): Observable<wsPayloadResponse> {
    if (this.guid == true) {
      this.token = Guid.create().toString();
    }
    let data = {
      "hangingSession": {
        "userName": userName,
      }
    }


    let body = {
      "token": this.token,
      "action": "stationsData",
      "data": data
    }
    // //console.log("body for reserveStation is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url + '/stationsData/hangingSession', body, httpOptions);
  }

    getLogs(stationId: string, userName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "diagnostics&",
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    getConfiguration(stationId: string, userName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "getConfiguration&",
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    setConfiguration(stationId: string, values: string, userName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "changeConfiguration&" + values,
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    setAuthList(stationId: string, userName: string): Observable<wsPayloadResponse> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "setLocalAuthList&",
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    updateFirmware(stationId: string, updateFirmware: FirmwareUpdate, userName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "firmwareUpdate&" + JSON.stringify(updateFirmware),
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    changeAvailability(stationId: string, obj: changeAvailability, userName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "changeAvailability&" + JSON.stringify(obj),
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    triggerMessage(stationId: string, command: string, userName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/device-cmd/additional-calls`;
        const body = {
            stationId: stationId,
            message: "triggerMessage&" + stationId + "&" + command,
            userName: userName
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
        }


        /*
            * FRAUD LATER
        */
    async getPosSessions(paginationOptions?: any): Promise<any> {
        return this.http.get(`${PlugpointEnvironment.url}/pos-central/sessions`, { headers: { "sessionid": Guid.create().toString() } }).toPromise();
    }
/**
    *  Get all POS
* @returns the ```Pos[]``` object if the POS is found
* @returns ```null``` if the POS is not found
*/
  async getAllPos(): Promise<Pos[]> {
    //     const resp = await fetch( PlugpointEnvironment.url +'/pos-central/', {
    //       method: 'GET',
    //       headers: {
    //           "Authorization": "Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==",
    //           "SessionID": Guid.create().toString()
    //       }
    //   })
    //   if (resp.ok) {
    //       return await resp.json()
    //   }
    //   return []
      return this.http.get<Pos[]>(PlugpointEnvironment.url + '/pos-central/', { headers: { "sessionid": Guid.create().toString() } }).toPromise();
  }

  /**
      * Get the details of a POS by its ID
  * @param posId - the ```string``` ID of the POS
  * @returns the ```Pos``` object if the POS is found
  * @returns ```null``` if the POS is not found
      */
    async getPosById(posId: string): Promise<Pos> {
        // const resp = await fetch(PlugpointEnvironment.url + '/pos-central/' + posId, {
        //     method: 'GET',
        //     headers: {
        //         "Authorization": "Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==",
        //         "SessionID": Guid.create().toString()
        //     }
        // })
        // if (resp.ok) {
        //     return await resp.json()
        // }
        // return null
        return this.http.get<Pos>(PlugpointEnvironment.url + '/pos-central/' + posId, { headers: { "sessionid": Guid.create().toString() } }).toPromise();
    }

    async addPosStations(stations: any[]): Promise<boolean> {
        return this.http.post<boolean>(PlugpointEnvironment.url + '/pos-central/stations', stations, { headers: {
                "Content-Type": "application/json", 'SessionID': Guid.create().toString() } }).toPromise();
    }
    async removePosStations(stations: any[]): Promise<boolean> {
        const stationIds = stations.map(s => s.stationId); // Extract station IDs

        // const resp = await fetch(`${PlugpointEnvironment.url}/pos-central/stations`, {
        //     method: 'DELETE',
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Authorization": "Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==",
        //         "SessionID": Guid.create().toString()
        //     },
        //     body: JSON.stringify(stationIds) // Send JSON array in body
        // });

        // return resp.ok;
        return this.http.request<boolean>('delete', PlugpointEnvironment.url + '/pos-central/stations', {
            headers: {
                "Content-Type": "application/json", 'SessionID': Guid.create().toString(),
                "SessionId": Guid.create().toString()
            },
            body: stationIds
        }).pipe(
            map(() => true),
            catchError(() => of(false))
        ).toPromise();
    }

    /**
        * Update the details of a POS
    * @param posId - the ```string``` ID of the POS
    * @param changes - the changes to be made - keys should be : ```location```, ```latitude```, ```longitude```, ```ip```
    * @returns ```boolean``` which signifies if the update was successful
    */
    async updatePos(posId: string, changes: any ): Promise<boolean> {
        // const resp = await fetch(PlugpointEnvironment.url + '/pos-central/' + posId, {
        //     method: 'PUT',
        //     headers: {
        //         "Authorization": "Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==",
        //         "SessionID": Guid.create().toString(),
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify(changes)
        // })
        // if (resp.ok) {
        //     return true
        // }
        // return false
        return this.http.put<boolean>(PlugpointEnvironment.url + '/pos-central/' + posId, changes, { headers: {
                "SessionID": Guid.create().toString(),
                "Content-Type": "application/json"} }).toPromise();
    }

    /**
        * Toggle the maintenance mode of a POS
    * @param posId - the ```string``` ID of the POS
    * @param value - the ```'on'``` or ```'off'``` value to toggle the maintenance mode
    * @returns the response from the server
    */
    async toggleMaintenance(posId: string, value: 'on' | 'off'): Promise<any> {
        return this.http.post(PlugpointEnvironment.url + '/pos-central/maintenance/'+ value, { posIds: [posId] }, { headers: {
                "SessionID": Guid.create().toString(),
                "Content-Type": "application/json"} }).toPromise();
        // const resp = await fetch(PlugpointEnvironment.url + '/pos-central/maintenance/' + value, {
        //     method: 'POST',
        //     headers: {
        //         "Authorization": "Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==",
        //         "SessionID": Guid.create().toString(),
        //         "Content-Type": "application/json"
        //     },
        //     body: `{ "posIds": ["${posId}"]}`
        // })
        // if (resp.ok) {
        //     return resp
        // }
        // return null
    }
    /**
        * Reboot a POS by sending an SQS message
    * @param posId - the ```string``` ID of the POS
    */
    async rebootPos(posId: string): Promise<any> {
        return this.http.get(PlugpointEnvironment.url + '/pos-central/' + posId + '/reboot', { headers: {
                "SessionID": Guid.create().toString()
            }
        }).toPromise();
        // if (resp.ok) {
        //     return resp
        // }
        // return null
    }
    async triggerFiscalEndDay(): Promise<any> {
        const resp = await fetch(PlugpointEnvironment.url + '/pos-central/trigger-fiscal-end-day-report', {
            method: 'GET',
            headers: {
                "SessionID": Guid.create().toString()
            }
        })
        if (resp.ok) {
            return await resp.json()
        }
        return null
    }
    /**
        * Request a heartbeat from a POS
    * @param posId - the ```string``` ID of the POS
    */
    async requestHeartbeat(posId: string): Promise<any> {
        return this.http.post(PlugpointEnvironment.url + '/pos-central/' + posId + '/request-heartbeat', {}, { headers: {
                "SessionID": Guid.create().toString()
            }
        }).toPromise();
        // const resp = await fetch(PlugpointEnvironment.url + '/pos-central/' + posId + '/request-heartbeat', {
        //     method: 'POST',
        //     headers: {
        //         "SessionID": Guid.create().toString()
        //     }
        // })
        // if (resp.ok) {
        //     return resp
        // }
        // return null
    }

    getStatusColor(stationStatus: any, stationReserved: boolean): any {
        switch (stationStatus) {
            case 'CHARGING':
            case 'SUSPENDEDEV':
            case 'CAR CONNECTED':
            case 'FINISHING':
            case 'SUSPENDEDEVSE':
            case 'PREPARING':
            case 'OCCUPIED':
                return 'rgb(5, 144, 224)';
            case 'AVAILABLE':
                return '#9BC53D';
            case 'RESERVED':
                return 'rgb(243, 166, 23)';
            case 'FAULTED':
            case 'UNAVAILABLE':
            case 'UNKNOWN':
            case 'ERR3':
            case 'OUT OF ORDER':
            case 'ERR':
            case 'ERRFAULTED':
            case 'OFFLINE':
                return 'rgb(253, 77, 62)';
        }
    }

  /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead


      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  subtractThreeDays(dateString: string): string {
    const date = new Date(dateString);
    date.setDate(date.getDate() - 3);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  addThreeDays(dateString: string): string {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 3);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}



// {
//   "token" : "4a46889db102438faa83b0b8151898a6",
//   "action" : "additionalCalls",
//   "data": "CnsKICAgICAgICAibXF0dE1lc3NhZ2UiIDogewogICAgICAgICAgICAidG9waWMiIDogInN0YXRpb24vMVNPQ0tFVCIsCiAgICAgICAgICAgICJtZXNzYWdlIiA6ICJnZXRDb25maWd1cmF0aW9uJiIKICAgICAgICB9CiAgICB9"
// }



export type Pos = {
    id: string;
    posId: string,
    location: string,
    latitude: number,
    longitude: number,
    eftId?: string;
    mfaId?: string;
    isInMaintenance: boolean,
    isMFBlocked: boolean,
    heartbeatAt: number,
    stationList: StationsInPos[]
}
type StationsInPos = {
    createdAt: number,
    updatedAt: number,
    deletedAt: number,
    id: number,
    stationId: string,
    connectorType: string,
    stationName: string,
    isReserved: boolean,
    reservationEndTime: number,
    reservationId: string
}
